
<template>
  <div id="basket_train_detail_outer" class="vue_body_min_height" >
    <div v-if="currentBanner != null">
      <div>
        <img id="match_top_img" :src="currentBanner.url">
      </div>
    </div>

    <div class="container">
      <div class="basket-match-card-title" ><span>{{subTabList[currentIndex].title}}</span></div>

      <div v-if="currentIndex == 2" class="rectange-outer" style="min-height: 285px;">

        <div style="color: #333;padding-top: 30px;font-size:1.5rem;padding-left: 10px;padding-right: 10px;">{{trainTitle}}</div>
        <div id="train_id_search_outer">
          <div>
            <span>学员姓名<br>Name</span>
            <div class="search-input-outer" >
              <el-input v-model="userName"></el-input>
              <span>请输入学员姓名；Please enter your name with space in between</span>
            </div>
          </div>
          <div>
            <span >证件号<br>Identification</span>
            <div class="search-input-outer">
              <el-input v-model="userID"></el-input>
              <span>请输入身份证号/台胞证号/护照号；Please enter your Identification number/Taiwan compatriots certificate number/ Passport number</span>
            </div>
          </div>

          <div style="text-align: center;">
            <el-button
              round
              @click="searchButtonClicked"
              style="color: white;background-color: #fc1a34;min-width: 150px;border-color: #fc1a34;" >查询&nbsp;Search</el-button>
          </div>
          <div>
<!--            <a href="mailto:shba@shslqxh.com?subject=test&cc=sample@hotmail.com&body=use mailto sample">发送邮件</a>-->
<!--            <a href="mailto:shba@shslqxh.com">发送邮件</a>-->
          </div>
        </div>

      </div>

      <div class="rectange-outer" >
        <train-list v-bind:listIndex="currentIndex" v-bind:tag="subTabList[currentIndex].title"/>
      </div>

    </div>

    <train-search-result-dialog v-if="showSearchResult" v-bind:userList="searchUserList" v-on:close="closeResultDialog"></train-search-result-dialog>

  </div>
</template>

<script>
  import GlobalInstance from '../js/shba'
  import TrainList from "../components/train/TrainList";
  import TrainSearchResultDialog from "../components/train/TrainSearchResultDialog";

  import { Loading } from 'element-ui';


  export default {
    name: "TrainingActivityListPage",
    components:{
      TrainList,
      TrainSearchResultDialog
    },
    data() {
      return {
        title: '篮球培训',
        trainItem: null,
        bootstrapMd: false,
        refereeIndex: 0,
        coachIndex: 0,
        userName: '',
        userID: '',

        trainTitle: '2021年上海市篮球协会篮球技能等级考试证书查询通道',
        showSearchResult: false,
        searchUserList: null,
      }
    },
    mounted() {

      let shareObj = this.$store.state.http.defaultShareObj;
      shareObj.title = '篮球培训 —— ' + this.subTabList[this.currentIndex].title;
      shareObj.link = location.href;
      this.configShareWx(encodeURIComponent(location.href), shareObj);
    },
    destroyed() {
    },
    computed: {
      httpManager() {
        return this.$store.state.http;
      },
      banners() {
        return this.$store.state.banners;
      },
      currentBanner() {
        if (this.banners == null) {
          return null;
        }
        let item = this.banners.find(function (item) {
          return  item.name == 'training';
        });

        if (item == undefined) {
          return null;
        }
        return item;
      },

      currentIndex() {
        return GlobalInstance.methods.subTabIndex(this.$route)
      },
      subTabList() {
        return GlobalInstance.methods.subMenuLlist(this.$route)
      },
    },
    methods: {
      closeResultDialog() {
        this.searchUserList = null;
        this.showSearchResult = false;
      },


      showFailPassMessage(name) {
        let message = "<div style=\"text-align: center;\">" +
          "很遗憾 " + "<span style='font-weight: bold'>" + name + "</span>" + " 未通过本次测试！" +
          "</div>"
        this.$confirm(
          message, '', {
            showCancelButton:false,
            showConfirmButton: false,
            showClose:false,
            closeOnClickModal: true,
            dangerouslyUseHTMLString: true
          }
        ).catch(function() {
          //...
        });
      },

      showNotFoundMessage() {
        let message = "<div style=\"text-align: center;\">" +
          "未查到该学员的相关信息！" +
          "</div>"
        this.$confirm(
          message, '', {
            showCancelButton:false,
            showConfirmButton: false,
            showClose:true,
            dangerouslyUseHTMLString: true
          }
        ).catch(function() {
          //...
        });
      },

      searchButtonClicked() {
        let userName = this.userName.removeNamesBlank();

        if (userName == '') {
          this.$toast('请输入学员的姓名');
          return;
        }

        let userID = this.userID.removeBlanks();
        if (userID == '') {
          this.$toast('请输入身份证号/台胞证号/护照号！');
          return;
        }

        let params = {
          idNo: userID,
          name: userName
        };
        let _this = this;


        let loadFlags = Loading.service({
          target: document.getElementById('app'),
          fullscreen: true
        });
        this.httpManager.ajax.getCredentialsData(params, function (res) {
          loadFlags.close();
          let code = res.code;

          if (code == 0) {
            let data = res.data;
            if (data == null || data.length == 0) {
              _this.showNotFoundMessage();
              return;
            }


            let status = data.status;

            let tmpList = [];
            for (let i = 0; i < data.length; i++) {
              let item = data[i];
              let status = item.status;
              if (status == 1) { // 通过考核
                tmpList.push(item);
              }
            }

            if (tmpList.length == 0) {
              _this.showFailPassMessage(data[0].name);
              return;
            }

            _this.searchUserList = tmpList;
            _this.showSearchResult = true;

            return;
          }
          _this.$toast('查询失败！');

        }, function (res) {
          loadFlags.close();
          _this.$toast('请求失败，请重试！');
        });

      },

    }
  }
</script>

<style scoped>
  #basket_train_detail_outer {
    padding-bottom: 80px;
    text-align: center;
  }

  #match_top_img {
    width: 100%;
    height: auto;
  }

  .basket-match-card-title {
    margin-top: 30px;
  }

  .basket-match-card-title span {
    font-size: 2rem;
    font-weight: bold;
    border-bottom: solid 2px #fc1a34;
    padding-bottom: 5px;
    letter-spacing: 1.5px;
  }

  #match_courses_center > div:last-child {
    margin-top: 30px;
  }

  #match_courses_center .course-item {
    /*height: 30px;*/
    position: relative;
    padding: 6px 0px;

    /*display: flex;*/
    /*flex-wrap: wrap;*/
    /*justify-content:center;*/
    /*align-items: center;*/
  }

  @media screen and (min-width: 768px) {
    #match_courses_center .course-item {
      /*justify-content:space-around;*/

    }
  }

  .course-item a {
    color: white;
    font-size: 1.5rem;
    text-decoration: none;
  }

  .course-item a:hover {
    color: #aaa;
  }


  #match_courses_center .course-bottom-border {
    border-bottom: solid 1px rgba(102, 102, 102, 0.15);
  }

  #course_item_outer {
    border-radius: 6px;
    background-color: #fc1a34;
  }


  .train-card {
    margin-top: 6vh;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
  }

  .train-card .image-item > img {
    width: 100%;
    height:auto;
  }

  .train-card .content-item {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .train-card .content-item > div {
    max-width: 90%;
    width: auto;
    text-align: left;
  }

  .train-card .content-item .item-a {
    color: #333;
    font-size: 1.5rem;
    text-decoration: none;
    display: block;
  }

  .train-card .content-item .item-a:not(:first-child) {
    margin-top: 10px;
  }

  .train-card .content-item .item-a:hover {
    color: #fc1a34;
  }

  .item-bottom-buttons {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
  }

  .item-bottom-buttons input {
    font-size: 1.5rem;
    border: none;
    background-color: #fc1a34;
    border-radius: 20px;
    color: white;
    padding: 10px 15px;
    margin-top: 20px;
    font-weight: bold;
    outline: none;
  }

  .rectange-outer {
    width: 100%;
    margin-top: 50px;
    min-height: 300px;
    box-shadow: 0 0 15px rgba(255,0,0, 0.15);
    border-radius: 6px;
    padding: 0;
  }

  #train_id_search_outer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex-wrap: nowrap;
    width: 100%;
    align-items: center;
    padding-left: 10px;
    margin-top: 30px;
    padding-right: 10px;
  }

  #train_id_search_outer > div {
    display: inline-flex;
    align-items: center;
    max-width: 700px;
    width: 100%;
    justify-content: center;
  }

  #train_id_search_outer > div:not(:first-child) {
    margin-top: 20px;
  }


  #train_id_search_outer > div > span {
    width: 160px;
    /*text-align: right;*/
    align-self: flex-start;
    margin-top: 5px;
  }

  #train_id_search_outer > div .search-input-outer {
    width: 89%;
    text-align: left;
  }

  #train_id_search_outer > div .search-input-outer > span {
    color: #999;
    margin-top: 5px;
    display: inline-block;
  }



  #train_id_search_outer /deep/ .el-input__inner:focus {
    border: solid 1px #fc1a34;
  }

  @media screen and (min-width: 768px) {
    #train_id_search_outer > div .search-input-outer {
      max-width: 540px;
      text-align: left;
      width: auto;
    }

    .train-card .content-item > div {
      max-width: 70%;
    }

    #match_coach .train-card {
      flex-direction: row-reverse;
    }
  }


</style>




// WEBPACK FOOTER //
// src/pages/TrainingActivityListPage.vue